import styled from "styled-components/macro";

export const Wrapper = styled.div`
  //position: fixed;
  width: 100%;
  height: 100%;
  //height: 100vh;
  //top: 0;
  //left: 0;
  //z-index: 999;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  & div {
    height: 500px;
    width: 500px;
  }
`;

export const Container = styled.div`
  position: relative;
`;

export const ListItemWrapper = styled.div<{dropStatus: string | undefined}>`
  & > div {
    transform: scale(${({dropStatus}) =>  dropStatus  ? 0.8 : 1});
    filter: contrast(${({dropStatus}) =>  dropStatus  ? 0.2 : 1});
  }
`;

export const ListItem = styled.div`

  position: relative;
  
  & .ant-upload-list-item-info {
    height: 84px;
  }
  
  &:hover > div > div {
    background: black;
  }
  &:hover > span {
    cursor: pointer;
    opacity: 1;
    color: red;
    z-index: 2;
    transition: .3s;

  }
  & > span {
    opacity: 0;
    position: absolute;
    top: 16px;
    right: 16px;
    transition: .3s;

    & svg {
      fill: white;
    }
  }
`;
